import { ASTNode } from "react-native-markdown-display";
import type MarkdownIt from "markdown-it";
import { RuleBlock } from "markdown-it/lib/parser_block.mjs";

const BLOCKQUOTES_IDENTIFIERS = ["> [success]", "> [warning]", "> [denger]"];

type RuleBlockArgs = Parameters<RuleBlock>;
type ExtendedRuleBlock = (
  identifiers: string[],
  ...args: RuleBlockArgs
) => boolean;

const parseCustomBlockWithTitle: ExtendedRuleBlock = (
  identifiers,
  state,
  startLine,
  endLine,
  silent,
) => {
  const pos = (state?.bMarks[startLine] ?? 0) + (state?.tShift[startLine] ?? 0);
  const max = state.eMarks[startLine];
  const line = state.src.slice(pos, max);

  if (!identifiers.some((id) => line.startsWith(id))) return false;
  if (silent) return true;

  const lastChartOfIdentifire = line.indexOf("]") + 1;
  const marker = line.slice(0, lastChartOfIdentifire);
  const rest = line.slice(lastChartOfIdentifire).trim();
  const title = rest;

  let content = "";
  let nextLine = startLine + 1;

  while (nextLine < endLine) {
    const lineStart =
      (state?.bMarks[nextLine] ?? 0) + (state?.tShift?.[nextLine] ?? 0);
    const lineEnd = state.eMarks[nextLine];
    const nextLineText = state.src.slice(lineStart, lineEnd);

    if (
      nextLineText.trim() === "" ||
      identifiers.some((id) => nextLineText.startsWith(id))
    ) {
      break;
    }

    content += nextLineText + "\n";
    nextLine++;
  }

  const token = state.push("custom_block", "div", 0);
  token.markup = marker.slice(3, lastChartOfIdentifire - 1);
  token.info = title;
  token.content = content.trimEnd();
  token.map = [startLine, nextLine];
  state.line = nextLine;

  token.children = [];
  state.md.block.parse(content, state.md, state.env, token.children);

  for (const child of token.children) {
    if (child.type === "inline") {
      state.md.inline.parse(
        child.content,
        state.md,
        state.env,
        (child.children = []),
      );
    }
  }

  return true;
};

const formatIdentifiers = (identifiers: readonly string[]) => {
  return identifiers.map((id) => {
    return id.startsWith(">") ? id : `> [${id}]`;
  });
};

export const customeBackquotes = (
  md: MarkdownIt,
  identifiers?: readonly string[],
) => {
  md.block.ruler.before("blockquote", "custom_block", (...args) =>
    parseCustomBlockWithTitle(
      identifiers ? formatIdentifiers(identifiers) : BLOCKQUOTES_IDENTIFIERS,
      ...args,
    ),
  );
};

export interface ExtendedASTNode extends ASTNode {
  sourceInfo: string | undefined;
}
